interface MaskIconProps {
  url: string;
  className?: string;
}

export function MaskIcon({ url, className = "" }: Readonly<MaskIconProps>) {
  return (
    <div
      className={`
        inline-block
        bg-current
        mask-center mask-no-repeat mask-contain
        ${className}
      `}
      style={{
        WebkitMaskImage: `url(${url})`,
        maskImage: `url(${url})`
      }}
    />
  );
}
